












import { Component } from 'vue-property-decorator'
import { DateTime } from 'luxon'

// mixins
import NotifyMixin from '@/mixins/NotifyMixin'
// store
import MasterExercisesModule from '@/store/modules/master/exercises'
// utils
import { convertSecondsToHoursMinutes } from '@/utils/functions'

@Component
export default class Timer extends NotifyMixin {
  private get exercise() {
    return MasterExercisesModule.exercise
  }

  private get duration() {
    if (this.exercise)
      return this.exercise.avgExecutionSeconds
    return 0
  }

  private get time() {
    return convertSecondsToHoursMinutes(this.seconds, true)
  }

  private seconds = this.exercise ? this.exercise.progress.workStartedAt ? Math.max(this.duration - Math.floor((Date.now() - (DateTime.fromSQL(this.exercise.progress.workStartedAt) as any).ts) / 1000), 0) : this.duration : 0

  private interval: number | null = null
  private isHide = false

  private mounted() {
    if (this.seconds > 0) {
      this.interval = setInterval(this.runTimer, 1000)
    }
  }

  private destroyed() {
    if (this.interval)
      clearInterval(this.interval)
  }

  private runTimer() {
    if (this.seconds <= 0 && this.interval) {
      this.notifyWarning('Время вышло! 😔')
      this.isHide = false
      clearInterval(this.interval)
      return
    }
    if (this.exercise && this.exercise.progress.workStartedAt)
      this.seconds = Math.max(this.duration - Math.floor((Date.now() - (DateTime.fromSQL(this.exercise.progress.workStartedAt) as any).ts) / 1000), 0)
  }
}
